import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-platform-dialog-definition-email-thread-editor',
  templateUrl: './platform-dialog-definition-email-thread-editor.component.html',
  styleUrls: ['./platform-dialog-definition-email-thread-editor.component.scss']
})
export class PlatformDialogDefinitionEmailThreadEditorComponent extends DialogDefinitionEditorBase implements OnInit, OnDestroy {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
